import { z } from "zod";
export const MAX_AGENT_ATTACHMENT_BYTES = 100_000_000;
export const MAX_AGENT_MESSAGE_ATTACHMENTS = 20;
/** Durable references only: storage keys, credentials and expiring URLs stay private. */
export const agentAttachmentSchema = z
    .object({
    id: z.uuid(),
    name: z.string().min(1).max(1_024),
    size: z.number().int().min(0).max(MAX_AGENT_ATTACHMENT_BYTES),
    mediaType: z.string().max(255),
    sha256: z.string().regex(/^[a-f0-9]{64}$/),
})
    .strict();
export const agentAttachmentsSchema = z
    .array(agentAttachmentSchema)
    .max(MAX_AGENT_MESSAGE_ATTACHMENTS)
    .refine((items) => new Set(items.map((item) => item.id)).size === items.length, "Attachment IDs must be unique");
export const agentAttachmentIdsSchema = z
    .array(z.uuid())
    .max(MAX_AGENT_MESSAGE_ATTACHMENTS)
    .refine((ids) => new Set(ids).size === ids.length, "Attachment IDs must be unique");
export const agentUploadBatchSchema = z
    .object({
    files: z
        .array(z
        .object({
        id: z.uuid(),
        name: z.string().min(1).max(1_024),
        size: z.number().int().min(0).max(MAX_AGENT_ATTACHMENT_BYTES),
        mediaType: z.string().max(255),
    })
        .strict())
        .min(1)
        .max(MAX_AGENT_MESSAGE_ATTACHMENTS),
})
    .strict();
export function agentAttachmentsEqual(left, right) {
    return ((left?.length ?? 0) === (right?.length ?? 0) &&
        (left ?? []).every((file, index) => {
            const other = right?.[index];
            return (other &&
                file.id === other.id &&
                file.name === other.name &&
                file.size === other.size &&
                file.mediaType === other.mediaType &&
                file.sha256 === other.sha256);
        }));
}
export const agentFileCatalogSchema = z
    .object({
    files: z
        .array(agentAttachmentSchema.extend({ messageId: z.uuid() }))
        .max(100),
    nextCursor: z.uuid().nullable(),
})
    .strict();
export function hasMessageContent(value) {
    return value.content.length > 0 || (value.attachments?.length ?? 0) > 0;
}
//# sourceMappingURL=attachments.js.map